import { isAxiosError } from 'axios';

const MAX_RETRIES = 3;

/**
 * React Query retry policy (#750, 2026-10-01 API pool incident).
 *
 * A client timeout, a cancelled request, or a 503/504 means the server is
 * already saturated or has cancelled the work. Retrying adds load to the
 * same database pool, so those fail fast and wait for the next scheduled
 * refetch. Other failures keep React Query's default of three retries.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  if (isAxiosError(error)) {
    if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') return false;
    if (error.code === 'ERR_CANCELED') return false;
    const status = error.response?.status;
    if (status === 503 || status === 504) return false;
  }
  return true;
}
